import Vue from 'vue'
import Router from 'vue-router'
// import Login from '../views/Login'
import Home from '../views/page-generator/Home.vue'
import ProductPage from '../views/page-generator/ProductPage.vue'
import ArticleShow from '../components/ui/ArticleShow'
import PosterGennerator from '../views/poster-generator/Index.vue'

// import Questionnaire from '@/views/Questionnaire/Questionnaire'
// import Statistics from '@/views/Questionnaire/Statistics'

Vue.use(Router)
/**
 * 解决报错：Navigating to current location (XXX) is not allowed
 * 原因：在路由中添加了相同的路由
 * 解决重写路由的push方法
 */
/* const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
} */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  try {
    return routerPush.call(this, location).catch(error => error)
  } catch (e) {

  }
}

Router.prototype.getRouteByName = function (name, children) {
  let array = this.options.routes
  if (children) {
    array = children
  }
  for (let index in array) {
    let route = array[index]
    if (route.name === name) {
      return route
    }
    if (route.children) {
      let child = this.getRouteByName(name, route.children)
      if (child) {
        return child
      }
    }
  }
}

let router = new Router({
  routes: [
    {
      name: 'Login',
      path: '/',
      component: () => import('@/views/Login')
    },

    // {
    //   name: 'Home',
    //   path: '/',
    //   component: Home
    // },
    {
      name: 'Home',
      path: '/product',
      component: Home
    },
    {
      name: 'ProductPage',
      path: '/productPage',
      component: ProductPage
    },
    {
      name: 'ProductPageMobile',
      path: '/productPageMobile',
      component: () => import('@/views/page-generator/ProductPageMobile'),
      meta: {
        title: '营销资料包'
      }
    },
    {
      name: 'ImagePage',
      path: '/imagePage',
      component: () => import('@/views/page-generator/ImagePage')
    },
    {
      name: 'VideoAndAudio',
      path: '/videoAndAudio',
      component: () => import('@/views/page-generator/VideoAndAudio')
    },
    {
      name: 'ArticleShow',
      path: '/article',
      component: ArticleShow
    },
    {
      name: 'PosterGennerator',
      path: '/posterGennerator',
      component: PosterGennerator
    },
    {
      name: 'BrokerPosterGennerator',
      path: '/brokerPosterGennerator',
      component: () => import('@/views/poster-generator/Broker')
    },
    {
      name: 'PosterTemplate',
      path: '/posterTemplate',
      component: () => import('@/views/poster-generator/PosterTemplate')
    },
    {
      name: 'ProductPoster',
      path: '/productPoster',
      component: () => import('@/views/poster-generator/ProductPoster')
    },
    {
      name: 'ProductPosterMobile',
      path: '/productPosterMobile',
      component: () => import('@/views/poster-generator/ProductPosterMobile'),
      meta: {
        title: '喜报'
      }
    },
    // {
    //   name: 'Danjuan',
    //   path: '/vote/danjuan',
    //   component: () => import('@/views/vote/IndexXueqiu'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'VotingPageXueqiu',
    //   path: '/vote/votingPageXueqiu',
    //   component: () => import('@/views/vote/VotingPageXueqiu'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'EndOfVotingXueqiu',
    //   path: '/vote/endOfVotingXueqiu',
    //   component: () => import('@/views/vote/EndOfVotingXueqiu'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'Tencentwm',
    //   path: '/vote/tencentwm',
    //   component: () => import('@/views/vote/IndexLicaitong'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'VotingPageLicaitong',
    //   path: '/vote/votingPageLicaitong',
    //   component: () => import('@/views/vote/VotingPageLicaitong'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'EndOfVotingLicaitong',
    //   path: '/vote/endOfVotingLicaitong',
    //   component: () => import('@/views/vote/EndOfVotingLicaitong'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'Antfortune',
    //   path: '/vote/antfortune',
    //   component: () => import('@/views/vote/IndexMayi'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'VotingPageMayi',
    //   path: '/vote/votingPageMayi',
    //   component: () => import('@/views/vote/VotingPageMayi'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'EndOfVotingMayi',
    //   path: '/vote/endOfVotingMayi',
    //   component: () => import('@/views/vote/EndOfVotingMayi'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'Eastmoney',
    //   path: '/vote',
    //   component: () => import('@/views/vote/IndexTiantian'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'VotingPageTiantian',
    //   path: '/vote/votingPageTiantian',
    //   component: () => import('@/views/vote/VotingPageTiantian'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    // {
    //   name: 'IndexBank',
    //   path: '/vote/indexBank',
    //   component: () => import('@/views/vote/IndexBank'),
    //   meta: {
    //     title: '500质量持有人大会'
    //   }
    // },
    {
      name: 'VotingPageBank',
      path: '/vote/votingPageBank',
      component: () => import('@/views/vote/Index'),
      meta: {
        title: '500质量持有人大会'
      }
    },
    // {
    //   name: 'QueryList',
    //   path: '/vote/queryList',
    //   component: () => import('@/views/vote/QueryList')
    // },
    // {
    //   name: 'AnnouncementFile',
    //   path: '/vote2/announcementFile',
    //   meta: {
    //     title: '公告',
    //     changeScalable: 'yes'
    //   },
    //   component: () => import('@/views/vote/AnnouncementFile')
    // },
    // {
    //   name: 'Index',
    //   path: '/vote2/index',
    //   component: () => import('@/views/vote/Index')
    // },
    {
      name: 'Voting',
      path: '/vote2/voting',
      component: () => import('@/views/vote/Voting')
    },
    // {
    //   name: 'Voting3',
    //   path: '/vote/voting3',
    //   component: () => import('@/views/vote/Voting3')
    // },
    {
      name: 'FileConvertedImage',
      path: '/fileConvertedImage',
      meta: {
        changeScalable: 'yes'
      },
      component: () => import('@/components/ui/FileConvertedImage')
    },
    {
      name: 'CommonArticle',
      path: 'commonArticle',
      component: () => import('@/views/common-article/Index'),
      children: [
        {
          name: 'CommonArticleList',
          path: '/commonArticleList',
          component: () => import('@/views/common-article/CommonArticleList')
        },
        {
          name: 'CommonArticleDetail',
          path: '/commonArticleDetail',
          component: () => import('@/views/common-article/CommonArticleDetail')
        },
        {
          name: 'CommonArticleSearch',
          path: '/commonArticleSearch',
          component: () => import('@/views/common-article/CommonArticleSearch')
        },
        {
          name: 'ArticleShared',
          path: '/articleShared',
          component: () => import('@/views/common-article/ArticleShared')
        }
      ]
    },
    {
      name: 'ProductArticle',
      path: 'productArticle',
      component: () => import('@/views/product-article/Index'),
      children: [
        {
          name: 'ProductArticleList',
          path: '/productArticleList',
          component: () => import('@/views/product-article/ProductArticleList')
        },
        {
          name: 'ProductArticleDetail',
          path: '/productArticleDetail',
          component: () => import('@/views/product-article/ProductArticleDetail')
        },
        {
          name: 'ProductArticleSearch',
          path: '/productArticleSearch',
          component: () => import('@/views/product-article/ProductArticleSearch')
        }
      ]
    },
    {
      name: 'CompleteInformation',
      path: '/completeInformation',
      component: () => import('@/views/user/CompleteInformation')
    },
    {
      name: 'UserVCard',
      path: '/userVCard',
      component: () => import('@/views/user/UserVCard'),
      meta: {
        title: '个人信息'
      }
    },
    {
      name: 'EditUserVCard',
      path: '/editUserVCard',
      component: () => import('@/views/user/EditUserVCard'),
      meta: {
        title: '个人信息'
      }
    },
    {
      name: 'ModifyUserVCard',
      path: '/modifyUserVCard',
      component: () => import('@/views/user/ModifyUserVCard')
    },
    {
      name: 'ShareUserVCard',
      path: '/shareUserVCard',
      component: () => import('@/views/user/ShareUserVCard'),
      meta: {
        title: '个人信息'
      }
    },
    {
      name: 'MarketingList',
      path: '/marketingList',
      component: () => import('@/views/productMarketing/MarketingList'),
      meta: {
        title: '营销资料包'
      }
    },
    {
      name: 'SearchMarketing',
      path: '/searchMarketing',
      component: () => import('@/views/productMarketing/SearchMarketing'),
      meta: {
        title: '营销资料包'
      }
    },
    {
      name: 'PosterList',
      path: '/posterList',
      component: () => import('@/views/goodNews/PosterList'),
      meta: {
        title: '喜报列表'
      }
    },
    {
      name: 'SearchPoster',
      path: '/searchPoster',
      component: () => import('@/views/goodNews/SearchPoster'),
      meta: {
        title: '喜报列表'
      }
    },
    {
      name: 'InvestManagerList',
      path: '/investManagerList',
      component: () => import('@/views/investManager/InvestManagerList'),
      meta: {
        title: '基金经理',
        keepalive: true
      }
    },
    {
      name: 'InvestManagerDetail',
      path: '/investManagerDetail',
      component: () => import('@/views/investManager/InvestManagerDetail'),
      meta: {
        title: '基金经理详情页'
      }
    },
    {
      name: 'FundDetail',
      path: '/fundDetail',
      component: () => import('@/views/investManager/FundDetail'),
      meta: {
        title: '基金经理详情页'
      }
    },
    {
      name: 'FundManagerSearch',
      path: '/fundManagerSearch',
      component: () => import('@/views/investManager/FundManagerSearch'),
      meta: {
        title: '基金经理'
      }
    },
    {
      name: 'AccessStatistics',
      path: '/accessStatistics',
      component: () => import('@/views/access-statistics/AccessStatistics'),
      meta: {
        title: '访问统计'
      }
    },
    {
      name: 'VisitSearch',
      path: '/visitSearch',
      component: () => import('@/views/access-statistics/VisitSearch'),
      meta: {
        title: '访问统计'
      }
    },
    {
      name: 'ArticleSearch',
      path: '/articleSearch',
      component: () => import('@/views/access-statistics/ArticleSearch'),
      meta: {
        title: '访问统计'
      }
    },
    {
      name: 'DetailSearch',
      path: '/detailSearch',
      component: () => import('@/views/access-statistics/DetailSearch'),
      meta: {
        title: '访问统计'
      }
    },
    {
      name: 'MyVisitorsDetail',
      path: '/myVisitorsDetail',
      component: () => import('@/views/access-statistics/MyVisitorsDetail'),
      meta: {
        title: '我的访客明细统计'
      }
    },
    {
      name: 'ArticleStatisticsDetail',
      path: '/articleStatisticsDetail',
      component: () => import('@/views/access-statistics/ArticleStatisticsDetail')
    },
    {
      name: 'DetailStatistics',
      path: '/detailStatistics',
      component: () => import('@/views/access-statistics/DetailStatistics')
    },
    {
      name: 'Product',
      path: 'product',
      component: () => import('@/views/product/Product'),
      children: [
        {
          name: 'ProductList',
          path: '/productList',
          component: () => import('@/views/product/ProductList'),
          meta: {
            title: '产品列表',
            keepalive: true
          }
        },
        {
          name: 'ProductSearch',
          path: '/productSearch',
          component: () => import('@/views/product/ProductSearch'),
          meta: {
            title: '产品搜索'
          }
        },
        {
          name: 'ProductDetail',
          path: '/productDetail',
          component: () => import('@/views/product/ProductDetail'),
          meta: {
            title: '基金详情'
          }
        },
        {
          name: 'ProductArchives',
          path: '/productArchives',
          component: () => import('@/views/product/ProductArchives'),
          meta: {
            title: '基金档案'
          }
        },
        {
          name: 'NoticeDetial',
          path: '/noticeDetial',
          component: () => import('@/views/product/common/NoticeDetial'),
          meta: {
            title: '基金公告'
          }
        },
        {
          name: 'HistoryUnitNav',
          path: '/historyUnitNav',
          component: () => import('@/views/product/HistoryUnitNav'),
          meta: {
            title: '历史净值'
          }
        },
        {
          name: 'HistoricalPerformance',
          path: '/historicalPerformance',
          component: () => import('@/views/product/HistoricalPerformance'),
          meta: {
            title: '历史业绩'
          }
        },
        {
          name: 'PreviousFundManagers',
          path: '/previousFundManagers',
          component: () => import('@/views/product/PreviousFundManagers'),
          meta: {
            title: '历任基金经理'
          }
        },
        {
          name: 'ProductArticle',
          path: '/productArticle',
          component: () => import('@/views/product/ProductArticle')
        }
      ]
    },
    {
      name: 'Disabled',
      path: '/disabled',
      component: () => import('@/views/user/Disabled')
    },
    {
      name: 'Live',
      path: 'live',
      component: () => import('@/views/live/Live'),
      children: [
        {
          name: 'LiveList',
          path: '/liveList',
          component: () => import('@/views/live/LiveList'),
          meta: {
            title: '直播汇总',
            keepalive: true
          }
        },
        {
          name: 'LiveSearch',
          path: '/liveSearch',
          component: () => import('@/views/live/LiveSearch'),
          meta: {
            title: '直播搜索',
            keepalive: true
          }
        },
        {
          name: 'LiveDetail',
          path: '/liveDetail',
          component: () => import('@/views/live/LiveDetail'),
          meta: {
            title: '直播间'
          }
        },
        {
          name: 'NotFound',
          path: '/notFound',
          component: () => import('@/views/live/NotFound')
        }
      ]
    },
    {
      name: 'Video',
      path: 'video',
      component: () => import('@/views/video/VideoIndex'),
      children: [
        {
          name: 'VideoList',
          path: '/videoList',
          component: () => import('@/views/video/VideoList'),
          meta: {
            title: '视频',
            keepalive: true
          }
        },
        {
          name: 'VideoDetail',
          path: '/videoDetail',
          component: () => import('@/views/video/VideoDetail'),
          meta: {
            title: '视频详情页',
            keepalive: false
          }
        },
        {
          name: 'VideoSearch',
          path: '/videoSearch',
          component: () => import('@/views/video/VideoSearch'),
          meta: {
            title: '视频搜索',
            keepalive: true
          }
        }
      ]
    },
    {
      name: 'OperationalReports',
      path: 'operationalReports',
      component: () => import('@/views/operationalReports/OperationalReports'),
      children: [
        {
          name: 'OperationalReportsList',
          path: '/operationalReportsList',
          component: () => import('@/views/operationalReports/OperationalReportsList'),
          meta: {
            title: '运作报告',
            keepalive: true
          }
        },
        {
          name: 'SearchOperationalReports',
          path: '/searchOperationalReports',
          component: () => import('@/views/operationalReports/SearchOperationalReports'),
          meta: {
            title: '运作报告搜索',
            keepalive: true
          }
        // },
        // {
        //   name: 'PreviewOperationalReports',
        //   path: '/PreviewOperationalReports',
        //   component: () => import('@/views/operationalReports/PreviewOperationalReports'),
        //   meta: {
        //     title: '预览'
        //   }
        }
      ]
    },
    {
      name: 'ProductEvent',
      path: 'productEvent',
      component: () => import('@/views/product-event/ProductEvent'),
      children: [
        {
          name: 'EventList',
          path: '/eventList',
          component: () => import('@/views/product-event/EventList'),
          meta: {
            title: '基金日历',
            keepalive: true
          }
        },
        {
          name: 'EventDetail',
          path: '/eventDetail',
          component: () => import('@/views/product-event/EventDetail'),
          meta: {
            title: '基金日常开放'
          }
        },
        {
          name: 'CalendarEventList',
          path: '/calendarEventList',
          component: () => import('@/views/product-event/CalendarEventList'),
          meta: {
            title: '日历事件',
            keepalive: true
          }
        },
        {
          name: 'EventSearch',
          path: '/eventSearch',
          component: () => import('@/views/product-event/EventSearch'),
          meta: {
            title: '基金日历',
            keepalive: true
          }
        },
        {
          name: 'MySubscription',
          path: '/mySubscription',
          component: () => import('@/views/product-event/MySubscription'),
          meta: {
            title: '我的订阅',
            keepalive: true
          }
        },
        {
          name: 'SubscriptionSearch',
          path: '/subscriptionSearch',
          component: () => import('@/views/product-event/SubscriptionSearch'),
          meta: {
            title: '搜索',
            keepalive: true
          }
        }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.changeScalable === 'yes') {
    document.getElementsByName('viewport')[0].content = 'user-scalable=yes,width=device-width,initial-scale=1.0'
  } else {
    document.getElementsByName('viewport')[0].content = 'width=device-width,initial-scale=1.0,user-scalable=no'
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js